import { App, type URLOpenListenerEvent } from "@capacitor/app";
import { usePlatform } from "../composables/platform";

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.hook("app:created", () => {
        const { isiOS } = usePlatform();
        const { public: config } = useRuntimeConfig();
        const $router = useRouter();

        if (isiOS.value) {
            App.addListener("appUrlOpen", function (event: URLOpenListenerEvent) {
                const slug = event.url.replace(`${config.CUSTOM_URL_SCHEME}://`, "/");

                // We only push to the route if there is a slug present
                if (slug) {
                    $router.push({
                        path: slug,
                    });
                }
            });
        }
    });
});
